import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ApiCallerService } from '../services/api-caller.service';
import {AngularFireDatabase} from 'angularfire2/database';
import { Observable, timer, Subscription } from 'rxjs';

@Component({
  selector: 'app-text-view',
  templateUrl: './text-view.component.html',
  styleUrls: ['./text-view.component.css']
})
export class TextViewComponent implements OnInit {


	@Input() isTeacher: boolean;


	@Output() exitLast = new EventEmitter();
	@Output() resetAll = new EventEmitter();
	@Output() stopStudentQuiz = new EventEmitter();
	@Output() startHistorical = new EventEmitter();

	totalChars = 0;
	teacher = true
	showView = false;
	answered = false;
	answer = "";
	allAnswers;
	counter = 0;
	question = "";
  	description = "";
  	actionSub: Subscription;

	whatUser(user){
		if (user) {
			this.teacher = true;
			this.showView = true;
		}
		else{
			this.teacher = false;
			this.showView = true;
		}
	}

	reset(){
		this.db.list('/Session-'+this.service.sessionId + "/action").remove();
		this.db.list('/Session-'+this.service.sessionId + "/action").push("reset");
		this.resetAll.emit();
	}

	OnInput(value){
		this.answer = value.target.value;
		this.totalChars = this.answer.length;
	}
	sendAnswer(){
		if (this.answer == "") {
			return;
		}
	this.db.list('/Session-'+ this.service.sessionId + "/textAnswer").push({
		"answer": this.answer, 
		"track" : this.service.selectedTrack
	});
	this.answered = true;

	}
	previousQuestion(){
		this.exitLast.emit();
		this.db.list('/Session-'+this.service.sessionId + "/action").remove();
		this.db.list('/Session-'+this.service.sessionId + "/action").push("historical");
	}

  constructor(
    private service: ApiCallerService,
    private db: AngularFireDatabase) { }

	ngOnInit() {



		// this.service.selectedTrack = 1;
		// this.service.sessionId = 669343;

		this.db.list('/Session-'+this.service.sessionId + "/textAnswer").valueChanges().subscribe((answer : any) => {
			this.allAnswers = answer;
			this.allAnswers.reverse();
		});
		this.question = this.service.quizQuestions[this.service.selectedTrack][4];


		this.actionSub = this.db.list('/Session-'+this.service.sessionId + "/action").valueChanges().subscribe((action: any) => {


            if (action.length == 0) {
              return;
            }
            if (action == "reset" ) {
              this.stopStudentQuiz.emit();
            }

	 		if (action == "historical"){
              this.service.currentQuestion--;
              this.startHistorical.emit();
            }

		});




	}

getColor(i){
  return "block"+ i%5;
}

  ngOnDestroy() {
    this.actionSub.unsubscribe();
  }

}
